import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';

import { AlertSnackbarContext } from '../../../components/snackbars';
import Api from '../../api/api';

export const deleteFeaturedBanner = async (id: string) => {
  const [response, bodyOrError] = await Api.delete(`featured-banner/${id}`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useDeleteFeaturedBanner = () => {
  const queryClient = useQueryClient();
  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation('deleteFeaturedBanner', deleteFeaturedBanner, {
    onSuccess: () => {
      setAlertSnackbar({
        message: 'Featured banner deleted successfully',
        severity: 'success',
        vertical: 'top',
      });
      queryClient.invalidateQueries('getAllFeaturedBanners');
    },
  });
};
